<template>
  <section>
    <modal-update-solicitation :value-modal="updateStatus" :title-modal="modalTitle"
                               :type-modal="modalType" :run-function="getDataChange"/>
    <!-- Top menu -->
    <top-menu/>
    <!-- Loading from page -->
    <full-loading v-if="loading"/>
    <!-- Content page -->
    <section v-else>
      <div class="page-content">
        <div class="container-fluid">
          <div class="col-md-12 solicitation">
            <div class="header">
              <span class="header-title">
                Detalhes da solicitação
                <span v-if="dataCode.status === 0" class="status-tag"
                      :style="{background: '#3A424E', color: '#FFFFFF'}">Não definido</span>
                <span v-if="dataCode.status === 1" class="status-tag"
                      :style="{background: '#FDD944', color: '#3a424e'}">Pendente</span>
                <span v-if="dataCode.status === 2" class="status-tag"
                      :style="{background: '#2F23D6', color: '#FFFFFF'}">Em progresso</span>
                <span v-if="dataCode.status === 3" class="status-tag"
                      :style="{background: '#2ACC6B', color: '#FFFFFF'}">Concluido</span>
                <span v-if="dataCode.status === 4" class="status-tag"
                      :style="{background: '#E6E9EC', color: '#3a424e'}">Cancelado</span>
                <a class="status-att" @click="openModalSolicitation(1, 'Atualizar solicitação')">
                  <ion-icon name="create-outline"/>
                  Atualizar Status
                </a>
              </span>
              <span class="header-subtitle">
                Solicitação criada em: {{ dataCode.createdAt | formatDate }} às {{ dataCode.createdAt | formatHors24 }}
              </span>
            </div>
            <div class="body">
              <div class="body-cards col-md-12 padding-null">
                <div class="cards col-md-4">
                  <div class="cards-content">
                    <span class="business-name">
                      {{ dataCode.name }}
                      <router-link
                        :to="{path: '/detalhes-da-empresa/' + dataCode.companyId + '/' + dataCode.contextCode}"
                        target="_blank">
                        <ion-icon name="open-outline"/>
                      </router-link>
                    </span>
                    <span class="business-id">{{ dataCode.companyId }}</span>
                  </div>
                </div>
                <div class="cards col-md-4">
                  <div class="cards-content cards-status">
                    <span class="cards-total">{{ dataCode.cards }} cartões</span>
                    <span class="line-blue"></span>
                    <span class="cards-details">
                      <span class="cards-first">
                        <b>{{ dataCode.cards }} </b>
                        cartões 1ª via
                      </span>
                      <span class="cards-drawer">
                        <b>{{ dataCode.drawer }} </b>
                        cartões gaveta
                      </span>
                    </span>
                  </div>
                </div>
                <div class="cards col-md-4">
                  <div class="cards-delivery">
                    <span class="delivery-label">Endereço de entrega:</span>
                    <span class="delivery-address">RUA {{ dataCode.address.street }}, {{
                        dataCode.address.number
                      }} - {{ dataCode.address.city }}/{{ dataCode.address.state }}</span>
                    <a class="delivery-edit" @click="openModalSolicitation(4, 'Editar endereço de entrega')">
                      <ion-icon name="create-outline"/>
                      Editar
                    </a>
                  </div>
                </div>
              </div>
              <div class="body-details col-md-12 padding-null">
                <div class="details-card col-md-4">
                  <div class="details-data details-solicitation">
                    <span class="details-title">
                      Dados da solicitação:
                    </span>
                    <span class="details-content">ID:
                      <b v-if="dataCode.id">{{ dataCode.id }}</b>
                      <b v-else>-</b>
                    </span>
                    <span class="details-content">Unidade de Negócio:
                      <b v-if="dataCode.businessUnitName">{{ dataCode.businessUnitName }}</b>
                      <b v-else>-</b>
                    </span>
                    <span class="details-content">Plano:
                      <b v-if="dataCode.subscription.plan">{{ dataCode.subscription.plan }}</b>
                      <b v-else>-</b>
                    </span>
                    <span class="details-content">Valor do plano:
                      <b v-if="dataCode.subscription.totalCost">{{ dataCode.subscription.totalCost }}</b>
                      <b v-else>-</b>
                    </span>
                    <span class="details-content">Valor benefício:
                      <b v-if="dataCode.subscription.benefitsPrice">{{ dataCode.subscription.benefitsPrice }}</b>
                      <b v-else>-</b>
                    </span>
                    <span class="details-content">Cobrar a partir de que mês:
                      <b v-if="dataCode.chargeNotes">{{ dataCode.chargeNotes }}</b>
                      <b v-else>-</b>
                    </span>
                    <span class="details-content">Observações:
                      <b v-if="dataCode.notes">{{ dataCode.notes }}</b>
                      <b v-else>-</b>
                    </span>
                  </div>
                </div>
                <div class="details-card col-md-4">
                  <div class="details-data details-requester">
                    <span class="details-title">
                      Dados do solicitante:
                      <a @click="openModalSolicitation(2, 'Editar dados do solicitante')">
                        <ion-icon name="create-outline"/>
                        Editar
                      </a>
                    </span>
                    <span class="details-content">Nome: <b>{{ dataCode.contactName }}</b></span>
                    <span class="details-content">Telefone: <b>{{ dataCode.contactPhone }}</b></span>
                    <span class="details-content">E-mail: <b>{{ dataCode.contactEmail }}</b></span>
                  </div>
                </div>
                <div class="details-card col-md-4">
                  <div class="details-data details-shipping">
                    <span class="details-title">
                      Dados do envio:
                      <a @click="openModalSolicitation(3, 'Editar dados do envio')">
                        <ion-icon name="create-outline"/>
                        Editar
                      </a>
                    </span>
                    <span class="details-content">Forma de envio:
                      <b v-if="!dataCode.deliveryOptions">-</b>
                      <b v-if="dataCode.deliveryOptions === 1">Sedex</b>
                      <b v-if="dataCode.deliveryOptions === 2">Pessoalmente</b>
                    </span>
                    <span class="details-content">Rastreio:
                      <b v-if="dataCode.trackCode">{{ dataCode.trackCode }}</b>
                      <b v-else>-</b>
                      <ion-icon @click="copyTracker(dataCode.trackCode)" v-if="dataCode.trackCode"
                                name="copy-outline"/></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 employees">
            <div class="header">
              <span>Funcionários selecionados</span>
            </div>
            <div class="body">
              <div class="body-table">
                <table class="content-table">
                  <thead>
                  <tr>
                    <th>
                      Funcionário
                      <ion-icon id="employees" v-on:click="orderSort('employees')"
                                name="caret-down-outline"></ion-icon>
                    </th>
                    <th>
                      Unidade de Negócio
                      <ion-icon id="businessUnit" v-on:click="orderSort('businessUnit')"
                                name="caret-down-outline"></ion-icon>
                    </th>
                    <th>
                      Status do cartão
                      <ion-icon id="cardStatus" v-on:click="orderSort('cardStatus')"
                                name="caret-down-outline"></ion-icon>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(value, index) in dataCode.users" :key="index">
                    <td class="content-employee">
                      <span class="employee-photo">
                        <img v-if="value.photo" :src="value.photo" alt="Foto">
                        <span v-else class="photo-empty">
                          <span>{{ value.name | firstLastName }}</span>
                        </span>
                      </span>
                      <span class="employee-data">
                        <router-link :to="{path: '/usuario/' + value.id + '/' + dataCode.contextCode}"
                                     target="_blank">{{ value.name }}</router-link>
                        {{ value.businessUnitName }}
                      </span>
                    </td>
                    <td class="content-unit">
                      <router-link
                        :to="{path: '/detalhes-da-empresa/' + value.businessUnitId + '/' + dataCode.contextCode}"
                        target="_blank">{{ value.businessUnitName }}
                      </router-link>
                    </td>
                    <td class="content-status">
                      <span v-if="value.status === 1" class="status-tag"
                            :style="{background: '#2ACC6B', color: '#FFFFFF', padding: '6px 35px'}">Ativo</span>
                      <span v-else-if="value.status === 2" class="status-tag"
                            :style="{background: '#FF9900', color: '#FFFFFF'}">Bloqueado</span>
                      <span v-else-if="value.status === 3" class="status-tag"
                            :style="{background: '#D5DFEB', color: '#3A424E'}">Cartão não vinculado</span>
                      <span v-else> - </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import modalUpdateSolicitation from "../../../modals/modalUpdateSolicitation";
import {
  REQUEST_SERVICE,
  UTIL_SERVICE
} from "../../../../../requestConfig";
import swal from "sweetalert";
import {
  CARD_DETAILS, GET_UNIT_MASTER
} from "../../../../../urlConfig";

export default {
  name: "request-details",
  components: {
    topMenu,
    fullLoading,
    modalUpdateSolicitation
  },
  data() {
    return {
      loading: false,
      dataCode: '',
      modalTitle: '',
      modalType: '',
      updateStatus: {
        solicitationData: {
          id: '',
          businessUnit: '',
          plan: '',
          planValue: '',
          benefitsValue: '',
          changeFrom: '',
          notes: '',
          status: '',
        },
        requesterData: {
          name: '',
          phone: '',
          email: '',
        },
        addressData: {
          city: '',
          country: '',
          number: '',
          street: '',
          state: '',
          zipCode: ''
        },
        shippingData: {
          trackCode: '',
          deliveryOptions: '',
        },
        businessUnitChange: '',
      },
    }
  },
  methods: {
    getData() {
      this.loading = true

      REQUEST_SERVICE.get(CARD_DETAILS + '/' + this.$route.params.orderId)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CARD_DETAILS:", response.data);

          this.dataCode = response.data;
          this.loading = false;
        })
        .catch((reason) => {
          this.loading = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getDataChange() {
      REQUEST_SERVICE.get(CARD_DETAILS + '/' + this.$route.params.orderId)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CARD_DETAILS:", response.data);

          this.dataCode = response.data;
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    orderSort(value) {
      $('#employees').css('transform', 'rotate(0deg)');
      $('#businessUnit').css('transform', 'rotate(0deg)');
      $('#cardStatus').css('transform', 'rotate(0deg)');

      this.dataCode.users = this.dataCode.users.sort(function (a, b) {
        let valueA = a[value];
        let valueB = b[value];
        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase().trim();
        }

        if (typeof valueB === 'string') {
          valueB = valueB.toLowerCase().trim();
        }

        if (valueA > valueB) {
          return 1;
        }
        if (valueA < valueB) {
          return -1;
        }
        return 0;
      });

      if (this[value + 'Order'] === true) {
        this.dataCode.users.reverse();
        $('#' + value).css('transform', 'rotate(0deg)');
      } else {
        $('#' + value).css('transform', 'rotate(180deg)');
      }

      this[value + 'Order'] = !this[value + 'Order']
    },
    openModalSolicitation(type, title) {

      if (type === 1) {
        $("body").css("cursor", "wait");

        REQUEST_SERVICE.requestContext('GET', GET_UNIT_MASTER + '?i=' + this.dataCode.companyId, this.dataCode.contextCode)
          .then((response) => {
            UTIL_SERVICE.console("RESULT GET_UNIT_MASTER:", response.data);

            $("body").css("cursor", "inherit");

            this.modalTitle = title;
            this.modalType = type;

            this.updateStatus = {
              solicitationData: {
                id: this.dataCode.id,
                businessUnit: this.dataCode.businessUnitName,
                plan: this.dataCode.subscription.plan,
                planValue: this.dataCode.subscription.totalCost,
                benefitsValue: this.dataCode.subscription.benefitsPrice,
                changeFrom: this.dataCode.subscription.chargeNotes,
                notes: this.dataCode.notes,
                status: this.dataCode.status,
                businessUnitId: this.dataCode.businessUnitId
              },
              requesterData: {
                name: this.dataCode.contactName,
                phone: this.dataCode.contactPhone,
                email: this.dataCode.contactEmail,
              },
              addressData: {
                city: this.dataCode.address.city,
                country: this.dataCode.address.country,
                number: this.dataCode.address.number,
                street: this.dataCode.address.street,
                state: this.dataCode.address.state,
                zipCode: this.dataCode.address.zipCode,
              },
              shippingData: {
                trackCode: this.dataCode.trackCode,
                deliveryOptions: this.dataCode.deliveryOptions,
              },
              additionalData: {
                companyId: this.dataCode.companyId,
                drawerCards: this.dataCode.drawer,
                qtdUsers: this.dataCode.users.length,
                contextCode: this.dataCode.contextCode,
                neighborhood: this.dataCode.address.neighborhood,
                complement: this.dataCode.address.complement,
                longitude: this.dataCode.address.longitude,
                latitude: this.dataCode.address.latitude,
                createdAt: this.dataCode.createdAt,
                cardOrderId: this.dataCode.id,
              },
              businessUnitChange: response.data,
            };

            $("#update-solicitation").modal();
          })
          .catch((reason) => {
            $("body").css("cursor", "inherit");
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        this.modalTitle = title;
        this.modalType = type;

        this.updateStatus = {
          solicitationData: {
            id: this.dataCode.id,
            businessUnit: this.dataCode.businessUnitName,
            plan: this.dataCode.subscription.plan,
            planValue: this.dataCode.subscription.totalCost,
            benefitsValue: this.dataCode.subscription.benefitsPrice,
            changeFrom: this.dataCode.subscription.chargeNotes,
            notes: this.dataCode.notes,
            status: this.dataCode.status,
            businessUnitId: this.dataCode.businessUnitIdentifer
          },
          requesterData: {
            name: this.dataCode.contactName,
            phone: this.dataCode.contactPhone,
            email: this.dataCode.contactEmail,
          },
          addressData: {
            city: this.dataCode.address.city,
            country: this.dataCode.address.country,
            number: this.dataCode.address.number,
            street: this.dataCode.address.street,
            state: this.dataCode.address.state,
            zipCode: this.dataCode.address.zipCode,
          },
          shippingData: {
            trackCode: this.dataCode.trackCode,
            deliveryOptions: this.dataCode.deliveryOptions,
          },
          additionalData: {
            companyId: this.dataCode.companyId,
            drawerCards: this.dataCode.drawer,
            qtdUsers: this.dataCode.users.length,
            contextCode: this.dataCode.contextCode,
            neighborhood: this.dataCode.address.neighborhood,
            complement: this.dataCode.address.complement,
            longitude: this.dataCode.address.longitude,
            latitude: this.dataCode.address.latitude,
            createdAt: this.dataCode.createdAt,
            cardOrderId: this.dataCode.id,
          }
        };

        $("#update-solicitation").modal();
      }
    },
    copyTracker(value) {
      navigator.clipboard.writeText(value)
    }
  },
  beforeMount() {
    this.getData();
  }
}
</script>

<style lang="scss" scoped>
.solicitation {
  padding: 30px;
  background: #FFFFFF;
  border-radius: 10px !important;

  .header {
    padding-bottom: 12px;
    border-bottom: 1px solid #E6E9EC;

    .header-title {
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: 700;
      color: #0F0F0F;

      .status-tag {
        padding: 6px 16px;
        font-size: 14px;
        font-weight: 400;
        border-radius: 4px !important;
        margin-left: 14px;
      }

      .status-att {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #2f23d6;
        margin-left: 15px;
        margin-top: 1px;

        ion-icon {
          width: 16px;
          height: 17px;
          margin-right: 3px;
        }
      }
    }

    .header-subtitle {
      font-size: 14px;
      font-weight: 400;
      color: #3A424E;
    }
  }

  .body {
    margin-top: 15px;

    .body-cards {
      .cards {
        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          padding-right: 0;
        }

        .cards-content {
          padding: 15px 20px;
          border-radius: 8px !important;
          background: #EEF2F7;

          .business-name {
            display: flex;
            font-weight: 700;
            font-size: 16px;
            color: #191919;
            line-height: 120%;
            margin-top: 1px;

            ion-icon {
              margin-left: 4px;
              font-size: 19px;
              color: #2F23D6;
              cursor: pointer;
            }
          }

          .business-id {
            font-weight: 400;
            font-size: 11px;
            color: #7F8897;
          }
        }

        .cards-status {
          display: flex;
          align-items: center;
          flex-direction: row;

          .cards-total {
            font-weight: 700;
            font-size: 24px;
            color: #3A424E;
          }

          .line-blue {
            width: 31px;
            height: 4px;
            background: #2F23D6;
            transform: rotate(-90deg);
          }

          .cards-details {
            display: flex;
            flex-direction: column;
          }
        }

        .cards-delivery {
          display: flex;
          flex-direction: column;
          padding: 5px 0;

          .delivery-label {
            font-weight: 400;
            font-size: 14px;
            color: #3A424E;
          }

          .delivery-address {
            font-weight: 700;
            font-size: 14px;
            color: #3A424E;
          }

          .delivery-edit {
            display: flex;
            align-items: center;
            color: #2F23D6;
            font-weight: 400;
            font-size: 14px;
            margin-top: 1px;

            ion-icon {
              margin-right: 3px;
              font-size: 15px;
            }
          }
        }
      }
    }

    .body-details {
      margin-top: 20px;

      .details-card {
        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          padding-right: 0;
        }

        .details-data {
          display: flex;
          flex-direction: column;

          .details-title {
            display: flex;
            flex-direction: row;
            align-items: flex-start;

            font-size: 18px;
            font-weight: 700;
            color: #191919;
            margin-bottom: 10px;

            a {
              display: flex;
              align-items: center;
              color: #2F23D6;
              font-size: 14px;
              font-weight: 400;
              margin-left: 10px;
              margin-top: 1px;

              ion-icon {
                width: 16px;
                height: 17px;
                margin-right: 3px;
              }
            }
          }

          .details-content {
            margin-bottom: 12px;
            font-weight: 400;
            font-size: 14px;
            color: #191919;

            &:last-child {
              margin-bottom: 0;
            }

            ion-icon {
              cursor: pointer;
              color: #7F8897;
              font-size: 15px;
              margin-bottom: -3px;
            }
          }
        }
      }
    }
  }
}

.employees {
  padding: 30px;
  background: #FFFFFF;
  border-radius: 10px !important;
  margin: 30px 0 140px 0;

  .header {
    span {
      font-size: 18px;
      font-weight: 700;
      color: #191919;
      margin-bottom: 20px;
    }
  }

  .body {
    .body-table {
      margin-top: 30px;

      .content-table {
        width: 99%;
        max-width: 99%;
        margin-bottom: 20px;

        thead {
          font-size: 14px;
          color: #7E8DA7;
          line-height: 220%;
          padding-bottom: 5px;
          border-bottom: 1px solid #E6E9EC;

          tr {
            th {
              font-weight: 500 !important;

              ion-icon {
                width: 13px;
                height: 13px;
                transition: .3s;
                cursor: pointer;
              }
            }
          }
        }

        tbody {
          tr {
            border-bottom: 1px solid #E6E9EC;

            .content-employee {
              padding: 12px 5px;
              display: flex;
              flex-direction: row;

              .employee-photo {
                img {
                  border-radius: 50% !important;
                  width: 41px;
                  height: 41px;
                }

                .photo-empty {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 41px;
                  height: 41px;
                  background: #E6E9EC;
                  border-radius: 50% !important;
                  margin-right: 7px;

                  span {
                    font-weight: 700;
                    font-size: 18px;
                  }
                }
              }

              .employee-data {
                display: flex;
                flex-direction: column;
                font-size: 11px;
                font-weight: 400;
                color: #3A424E;
                margin-left: 7px;

                a {
                  color: #2F23D6;
                  font-size: 16px;
                  font-weight: 500;
                }
              }
            }

            .content-unit {
              a {
                color: #2F23D6;
                font-size: 16px;
                font-weight: 500;
              }
            }

            .content-status {
              .status-tag {
                padding: 6px 14px;
                font-size: 14px;
                font-weight: 400;
                border-radius: 4px !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/cardsDetail/request-details.vue